import { render, staticRenderFns } from "./classWork.vue?vue&type=template&id=772fa441&scoped=true"
import script from "./classWork.vue?vue&type=script&lang=js"
export * from "./classWork.vue?vue&type=script&lang=js"
import style0 from "./classWork.vue?vue&type=style&index=0&id=772fa441&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772fa441",
  null
  
)

export default component.exports